<template>
    <div class="panel">
        <h5>Customer details</h5>

        <div class="form-group row">
            <div class="col-sm-4">
                <label>
                    First Name <span class="color-6">*</span>
                </label>

                <div v-if="getNamePrefixList" class="d-flex mb-3">
                    <v-select
                        class="glued-right"
                        v-model="selectedPrefix"
                        :options="getNamePrefixList"
                        :searchable="false"
                        label="description"
                        placeholder="- Select title -"
                        @input="updatePrefix">
                    </v-select>

                    <input type="text" class="full glued-left" v-model="form.customer.name">
                </div>
            </div>

            <div class="col-sm-4">
                <label>
                    Surname <span class="color-6">*</span>
                </label>
                <input type="text" class="full" v-model="form.customer.surname">
            </div>

            <div v-if="getLanguages" class="col-sm-4">
                <label>Language</label>

                <v-select
                    v-model="selectedLanguage"
                    :options="getLanguages"
                    :searchable="false"
                    label="name"
                    placeholder="- Select language -"
                    @input="updateLanguage">
                </v-select>
            </div>
        </div>

        <div v-if="getCountries"  class="form-group row">
            <div class="col-sm-4">
                <label>Nationality</label>

                <v-select
                    v-model="selectedCountry"
                    :options="getCountries"
                    :searchable="false"
                    label="name"
                    placeholder="- Select country -"
                    @input="updateCountry">
                </v-select>
            </div>

            <div class="col-sm-8">
                <label>
                    Phone Number <span class="color-6">*</span>
                </label>

                <div class="d-flex form-group">
                    <div class="glued-right country-code">{{ form.customer.countryDial }}</div>
                    <input type="text" class="glued-left" v-model="form.customer.phone">
                </div>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-sm-4">
                <label>Accomodation</label>
                <input type="text" class="full" v-model="form.customer.accomodation">
            </div>

            <div class="col-sm-4">
                <label>Room</label>
                <input type="text" class="full" v-model="form.customer.room">
            </div>
        </div>

        <div class="form-group row">
            <div class="col-sm-12">
                <label>
                    Email <span class="color-6">*</span>
                </label>
            </div>

            <div class="col-sm-4">
                <input type="email" class="full" v-model="form.customer.email">
            </div>

            <div class="col-sm-4">
                <label class="mt-2">
                    <checkbox v-model="form.customer.sendEmail">
                        Send a copy to this email
                    </checkbox>
                </label>
            </div>
        </div>

        <div class="mt-5">
            <div class="d-flex align-items-center">
                <i class="ico-wheelchair color-1 largest"></i>
                <checkbox v-model="form.customer.isSpecialAssistanceRequired">For special assistance, tick this box.</checkbox>
            </div>

            <div v-if="form.customer.isSpecialAssistanceRequired" class="mt-3">
                <textarea
                    placeholder="Type your needs, so we can provide you the best assistance ..."
                    v-model="form.customer.specialAssistanceNote">
                </textarea>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        data: function () {
            return {
                form: {},
                hasSpecialNeeds: false,
                defaultCountry: null,
                defaultLanguage: null,
                defaulPrefix: null,
                selectedPrefix: null,
                selectedCountry: null,
                selectedLanguage: null
            }
        },
        created: function() {
            this.form = this.getClonedReservation;

            if (this.getClonedReservation.customer === undefined || !this.getClonedReservation.customer) {
                this.initCustomer();
            }

            this.setDefaults();

            this.selectedCountry = this.defaultCountry;
            this.selectedLanguage = this.defaultLanguage;

            // set prefix
            if (this.form.customer.prefix) {
                this.selectedPrefix = this.getNamePrefixList.find(item => item.id === this.form.customer.prefix);
            }
            else {
                this.selectedPrefix = this.getNamePrefixList[0];
                this.form.customer.prefix = this.getNamePrefixList[0].id;
            }
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
                'getCountries',
                'getLanguages',
                'getNamePrefixList'
            ]),
        },
        methods: {
            ...mapActions([
                'updateClonedReservation'
            ]),
            initCustomer: function() {
                this.$set(this.form, 'customer', {
                    prefix: null,
                    name: null,
                    surname: null,
                    language: null,
                    phone: null,
                    accomodation: null,
                    room: null,
                    email: null,
                    country: null,
                    countryDial: null,
                    sendEmail: null,
                    specialAssistanceNote: '',
                    isSpecialAssistanceRequired: false,
                });
            },
            setDefaults: function() {
                this.defaultCountry = this.getCountries.find(i => i.default === true);
                this.defaultLanguage = this.getLanguages.find(i => i.default === true);

                // In case we didn't find a default: true

                if (this.defaultCountry === undefined) {
                    this.defaultCountry = this.getCountries[0];
                }

                if (this.defaultLanguage === undefined) {
                    this.defaultLanguage = this.getLanguages[0];
                }
            },
            setSpecialNeeds: function(e) {
                this.hasSpecialNeeds = !this.hasSpecialNeeds;
            },
            updatePrefix: function() {
                this.form.customer.prefix = this.selectedPrefix.id || this.getNamePrefixList[0].id;
            },
            updateLanguage: function() {
                let chosen = this.getLanguages.find(i => { return i.code === this.selectedLanguage.code });

                if (chosen) {
                    this.form.customer.language = chosen.code;
                }
                else {
                    this.form.customer.language = this.defaultLanguage;
                }
            },
            updateCountry: function() {
                let chosen = this.getCountries.find(i => { return i.id === (this.selectedCountry.id) });

                if (chosen) {
                    this.form.customer.country = chosen.id || this.defaultCountry.id;
                    this.form.customer.countryDial = chosen.dial || this.defaultCountry.dial;
                }
                else {
                    this.form.customer.country = this.defaultCountry.id || null;
                    this.form.customer.countryDial = this.defaultCountry.dial || null;
                }
            }
        },
        components: {
            vSelect: extendedVSelect
        },
        watch: {
            form: {
                handler: function (n, o) {
                    this.$emit('updateFields', { customer: n.customer });
                },
                deep: true
            }
        },
    }
</script>

<style lang="scss" scoped>
    .country-code {
        width: 75px;
    }
</style>



// WEBPACK FOOTER //
// Customer.vue?bf12b22e